import { render } from "./SwitchToggle.vue?vue&type=template&id=18b7e684"
import script from "./SwitchToggle.vue?vue&type=script&lang=js"
export * from "./SwitchToggle.vue?vue&type=script&lang=js"

import "./SwitchToggle.vue?vue&type=style&index=0&id=18b7e684&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__